//BookWorldListComponents.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Tooltip from '../../components/utils/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faCheck, faClipboardCheck, faDiamond, faSpinner, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import './styles/BookShelfListComponent.css';

const BookWorldListComponent = ({ param1, param2 }) => {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();

    const [bookMasters, setBookMasters] = useState([]);
    const [miniBookMasters, setMiniBookMasters] = useState([]);
    const [miniBookMastersLength, setMiniBookMastersLength] = useState(0);

    const [noOfBooks, setNoOfBooks] = useState(0);
    const [myBooks, setMyBooks] = useState([]);
    const [bookCollection, setBookCollection] = useState([]);

    const [selectedBookId, setSelectedBookId] = useState(null);

    const [searchGroup, setSearchGroup] = useState();
    const [searchText, setSearchText] = useState();

    useEffect(() => {
        setSearchGroup(param1);
        setSearchText(param2);
    }, [param1, param2]);

    const [bookHighlightClicked, setBookHighlightClicked] = useState(false);
    const [showHighlights, setShowHighlights] = useState(false);
    const [highlightStates, setHighlightStates] = useState({});
    const [collectionStates, setCollectionStates] = useState({});
    const [subCollectionBooks, setSubCollectionBooks] = useState({});
    const [bookMasterRecords, setBookMasterRecords] = useState({});

    const [collectionBooksToSave, setCollectionBooksToSave] = useState([]);

    const fetchBookMasters = useCallback(() => {
        const config = {
            url: "/bookmasters",
            method: "get",
            headers: {
                Authorization: authState.token,
                "Content-Type": "application/json",
            },
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response.bookmasters)) {
                    setBookMasters(response.bookmasters);
                    setBookMasterRecords(response.bookmasters.length);
                } else {
                    console.error("Invalid response format: Books not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching BookMasters:", error);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchBookMasters();
    }, [authState.isLoggedIn, fetchBookMasters]);

    const fetchMyBooks = useCallback(() => {
        const config = {
            url: "/mybooks",
            method: "get",
            headers: { Authorization: authState.token },
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response.mybooks)) {
                    setMyBooks(response.mybooks);
                } else {
                    console.error("Invalid response format: Book not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching MyBooks:", error);
            });
    }, [authState.token, fetchData]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchMyBooks();
    }, [authState.isLoggedIn, fetchMyBooks]);


    const fetchCollectionBooks = useCallback(() => {
        const config = {
            url: "/bookcollections",
            method: "get",
            headers: {
                Authorization: authState.token,
                "Content-Type": "application/json",
            },
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response) {
                    setBookCollection(response);
                } else {
                    console.error("Invalid response format: Book Collection not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Book Collection:", error);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchCollectionBooks();
    }, [authState.isLoggedIn, fetchCollectionBooks]);

    useEffect(() => {

    }, [bookCollection]);


    const formatDate = (date) => {
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        return `${month}-${day}-${year}`;
    };

    const prepareSaveCollectionBooks = (collectionId, bookCollection, bookMasters, myBooks, userId, authState) => {
        const currentDate = new Date();
        const subscriptionEndDateFromNow = new Date();
        subscriptionEndDateFromNow.setFullYear(subscriptionEndDateFromNow.getFullYear() + 3);
        const finalBookCollection = bookCollection.filter(book => book.collectionId === collectionId);

        const newCollectionBooks = [];

        finalBookCollection.forEach(async (book) => {
            const found = myBooks.some((myBook) => myBook.bookId === book.bookId);
            if (!found) {
                const bookMaster = bookMasters.find(master => master._id === book.bookId);
                if (bookMaster) {
                    const requestData = {
                        userId: userId,
                        bookId: bookMaster._id,
                        collectionId: book.collectionId,
                        collectionTitle: book.collectionTitle,
                        isT5W: bookMaster.isT5W,
                        bookCode: bookMaster.bookCode,
                        bookTitle: bookMaster.bookTitle,
                        bookAuthor: bookMaster.bookAuthor,
                        bookPages: bookMaster.bookPages,
                        bookImage: bookMaster.bookImage,
                        bookAPI: bookMaster.bookAPI,
                        isChildren: bookMaster.isChildren,
                        isSubscription: 0,
                        subscriptionEndDate: subscriptionEndDateFromNow,
                        purchaseDate: currentDate,
                        isActive: 1,
                        isDeleted: 0,
                        language: bookMaster.language,
                        bookCollectionName: bookMaster.bookCollectionName,
                        lastPageRead: 1,
                        bookSubject: bookMaster.subject,
                        bookCategory: bookMaster.category,
                        bookSubCategory: bookMaster.subCategory,
                        remarks: "Purchased as collection of " + book.collectionTitle,
                        bookHighlight: bookMaster.bookHighlight,
                        displayIndex: bookMaster.displayIndex,
                        hasAssignment: bookMaster.hasAssignment,
                        hasCertificate: bookMaster.hasCertificate,
                        hasExam: bookMaster.hasExam,
                        hasPracticeTest: bookMaster.hasPracticeTest,
                        coverPrice: bookMaster.coverPrice,
                        offerPrice: bookMaster.offerPrice,
                        hasDiscountedPrice: bookMaster.hasDiscountedPrice,
                        discountedPrice: bookMaster.discountedPrice,
                        discountCouponCode: '',
                        discountCouponMasterId: '',
                        discountCouponRedeemedBy: userId,
                        discountAmount: bookMaster.offerPrice - bookMaster.discountedPrice,
                        discountPercent: ((bookMaster.offerPrice - bookMaster.discountedPrice) / bookMaster.offerPrice) * 100,
                        discountCurrency: "INR",
                        paymentAmount: 0,
                        paymentMode: '',
                        paymentDate: currentDate,
                        transactionId: '',
                        paymentRemarks: '',
                        isGifted: 0,
                        giftCouponCode: '',
                        corpCode: '',
                        entityName: '',
                        employeeCode: '',
                        giftFor: '',
                        giftMessage: '',
                        gifterSignatureLine: '',
                        gifterName: '',
                        giftThankYouMessage: '',
                        giftCouponMasterId: '',
                        giftedTo: '',
                        isAudioBook: bookMaster.isAudioBook,
                        isTVBook: bookMaster.isTVBook,
                        isARBook: bookMaster.isARBook,
                        isDictaBook: bookMaster.isDictaBook,
                        isFlipBook: bookMaster.isFlipBook,
                        isPictureBook: bookMaster.isPictureBook,
                        isTextBook: bookMaster.isTextBook,
                        isTouchBook: bookMaster.isTouchBook,
                        isVideoBook: bookMaster.isVideoBook,
                        freeReads: bookMaster.freeReads,
                        paidReads: bookMaster.paidReads,
                    };
                    newCollectionBooks.push(requestData);
                } else {
                    console.error('Book not found in bookMasters:', book.id);
                }
            } else {
                console.error('Book already exists in myBooks:', book.id);
            }
        });
        return newCollectionBooks;
    };

    const handleBookDetailsClick = (bookId, collectionTitle, book, hasPurchased, isFree, isCollection) => {
        const userId = authState.user._id;
        let collectionToSave = null;
        if (isCollection) {
            collectionToSave = prepareSaveCollectionBooks(bookId, bookCollection, bookMasters, myBooks, userId, authState);
        }
        navigate('/buying-bookdetails', {
            state:
            {
                bookId: bookId,
                bookData: book,
                hasPurchased: hasPurchased,
                collectionToSave: collectionToSave,
                isCollection: isCollection
            }
        });
    };

    const handleBookHighlightClick = () => {
        setShowHighlights(!showHighlights);
    };

    const toggleHighlight = (bookId) => {
        setHighlightStates((prevState) => ({
            ...prevState,
            [bookId]: !prevState[bookId]
        }));
    };

    const toggleCollectionBookList = (bookId) => {
        const isCurrentlyVisible = collectionStates[bookId];
        setCollectionStates(prevState => ({
            ...prevState,
            [bookId]: !isCurrentlyVisible
        }));

        if (!isCurrentlyVisible) {
            const filteredBooks = bookCollection.filter(collectionbooks =>
                collectionbooks.collectionId.toString() === bookId.toString()
            );
            setSubCollectionBooks(prevState => ({
                ...prevState,
                [bookId]: filteredBooks
            }));
        }
    };

    const toProperCase = (str) => {
        if (str.toLowerCase() === 'cdr') {
            return 'Cultural.Devotional.Religious';
        }
        if (str.toLowerCase() === 'madsmania') {
            return 'MADSmania';
        }
        return str.replace(/\w\S*/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };


    const filteredAndSortedBooks = (books, param2) => {
        let miniBookMasters = [];
        switch (param2.toLowerCase()) {
            case 'audio':
                miniBookMasters = books.filter(book => book.isAudioBook && book.isAvailable === 1);
                break;
            case 'flip':
                miniBookMasters = books.filter(book => book.isFlipBook && book.isAvailable === 1);
                break;
            case 'picture':
                miniBookMasters = books.filter(book => book.isPictureBook === 1 && book.isAvailable === 1);
                break;
            case 'video':
                miniBookMasters = books.filter(book => book.isVideoBook === 1 && book.isAvailable === 1);
                break;
            case 'tv':
                miniBookMasters = books.filter(book => book.isTVBook && book.isAvailable === 1);
                break;
            case 'ar':
                miniBookMasters = books.filter(book => book.isARBook && book.isAvailable === 1);
                break;
            case 'text':
                miniBookMasters = books.filter(book => book.isTextBook === 1 && book.isAvailable === 1);
                break;
            case 'think5whys':
                miniBookMasters = books.filter(book => book.isT5W === 1 && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'children':
                miniBookMasters = books.filter(book => book.isChildren === 1 && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'collections':
                miniBookMasters = books.filter(book => book.isCollection && book.isAvailable === 1);
                break;
            case 'think5whys':
                miniBookMasters = books.filter(book => book.isT5W === 1 && book.isAvailable === 1);
                break;
            case 'madsmania':
                miniBookMasters = books.filter(book => book.tabGroup === 'madsmania' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'purplepower':
                miniBookMasters = books.filter(book => book.tabGroup === 'purplepower' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'professional':
                miniBookMasters = books.filter(book => book.tabGroup === 'professional' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'stem':
                miniBookMasters = books.filter(book => book.tabGroup === 'stem' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'arts':
                miniBookMasters = books.filter(book => book.tabGroup === 'arts' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'commerce':
                miniBookMasters = books.filter(book => book.tabGroup === 'commerce' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'law':
                miniBookMasters = books.filter(book => book.tabGroup === 'law' && book.isCollection === false && book.isAvailable === 1);
                break;   
            case 'lifescience':
                miniBookMasters = books.filter(book => book.tabGroup === 'lifescience' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'competition':
                miniBookMasters = books.filter(book => book.tabGroup === 'competition' && book.isCollection === false && book.isAvailable === 1);
                break;           
            case 'academics':
                miniBookMasters = books.filter(book => book.tabGroup === 'academics' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'youngadults':
                miniBookMasters = books.filter(book => book.tabGroup === 'youngadults' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'mature':
                miniBookMasters = books.filter(book => book.tabGroup === 'mature' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'agrilink':
                miniBookMasters = books.filter(book => book.tabGroup === 'agrilink' && book.isCollection === false && book.isAvailable === 1);
                break;   
            case 'ageless':
                miniBookMasters = books.filter(book => book.tabGroup === 'ageless' && book.isCollection === false && book.isAvailable === 1);
                break;  
            case 'sakshamshakti':
                miniBookMasters = books.filter(book => book.tabGroup === 'sakshamshakti' && book.isCollection === false && book.isAvailable === 1);
                break; 
            case 'MSME':
                miniBookMasters = books.filter(book => book.tabGroup === 'MSME' && book.isCollection === false && book.isAvailable === 1);
                break;                                                                 
            case 'msmemonthly':
                miniBookMasters = books.filter(book => book.tabGroup === 'MSMEMonthly' && book.isCollection === false && book.isAvailable === 1);
                break;                   
            case 'mindspark':
                miniBookMasters = books.filter(book => book.tabGroup === 'mindspark' && book.isCollection === false && book.isAvailable === 1);
                break;  
            case 'syntramfg':
                miniBookMasters = books.filter(book => book.tabGroup === 'syntramfg' && book.isCollection === false && book.isAvailable === 1);
                break;    
            case 'golden7':
                miniBookMasters = books.filter(book => book.tabGroup === 'golden7' && book.isCollection === false && book.isAvailable === 1);
                break;  
            case 'matrika':
                miniBookMasters = books.filter(book => book.tabGroup === 'matrika' && book.isCollection === false && book.isAvailable === 1);
                break;      
            case 'bluecollar':
                miniBookMasters = books.filter(book => book.tabGroup === 'bluecollar' && book.isCollection === false && book.isAvailable === 1);
                break;  
            case 'genz':
                miniBookMasters = books.filter(book => book.tabGroup === 'genz' && book.isCollection === false && book.isAvailable === 1);
                break;  
            case 'sanatan':
                miniBookMasters = books.filter(book => book.tabGroup === 'sanatan' && book.isCollection === false && book.isAvailable === 1);
                break;                     
            case 'recreational':
                miniBookMasters = books.filter(book => book.tabGroup === 'recreational' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'fiction':
                miniBookMasters = books.filter(book => book.tabGroup === 'fiction' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'nonfiction':
                miniBookMasters = books.filter(book => book.tabGroup === 'nonfiction' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'cdr':
                miniBookMasters = books.filter(book => book.tabGroup === 'cdr' && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'bestsellers':
                miniBookMasters = books.filter(book => book.isBestSeller === 1);
                break;
            case 'free':
                miniBookMasters = books.filter(book => book.isFree === 1 && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'suggested':
                miniBookMasters = books.filter(book => book.isPromotional === 1 && book.isAvailable === 1);
                break;
            case 'upcoming':
                miniBookMasters = books.filter(book => book.isUpcoming === 1);
                break;
            case 'competitive':
                miniBookMasters = books.filter(book => book.isCompetitive === 1 && book.isCollection === false && book.isAvailable === 1);
                break;
            case 'courses':
                miniBookMasters = books.filter(book => book.isCourse && book.isAvailable === 1);
                break;
            case 'program':
                miniBookMasters = books.filter(book => book.isProgram && book.isAvailable === 1);
                break;
            case 'publishers':
                miniBookMasters = books.filter(book => book.isPublisher && book.isAvailable === 1);
                break;
            case 'institutional':
                miniBookMasters = books.filter(book => book.isInstitutional && book.isAvailable === 1);
                break;
            case 'msme':
                miniBookMasters = books.filter(book => book.isInstitutional && book.isAvailable === 1);
                break;             
            default:
                miniBookMasters = books.filter(book => book.isPromotional === 1);
                break;
        }
        return miniBookMasters.sort((a, b) => a.displayIndex - b.displayIndex);
    };

    const scrollToDetail = (bookCode) => {
        const detailElement = document.getElementById(`book-detail-${bookCode}`);
        if (detailElement) {
          detailElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          console.error(`Detail section for bookCode ${bookCode} not found.`);
        }
      };

    return (
        <div className="book-list flex items-center">
            {loading ? (
                <div className="spinner-container">
                    <div className="spinner">
                        <FontAwesomeIcon icon={faSpinner} spin />
                    </div>
                </div>
            ) : (
                <>
                    <div className='ml-2 mr-2 flex flex-col items-center text-white'>
                        <div className='flex flex-col items-center justify-center text-center'>
                            <div className='text-white text-2xl mt-4'>
                            <p>
                                {toProperCase(param2)}{' '}{'Books World'}
                            </p>
                            </div>
                            {bookMasterRecords < 1 && (
                            <div className='text-yellow-500 text-2xl mt-4'>
                                <p>
                                Currently no Books are Available in {toProperCase(param2)}{' '}{'Books World'}!!
                                </p>
                            </div>
                            )}
                        </div>
                        <div className='image-container flex flex-row flex-wrap justify-center mt-4'>
                            {filteredAndSortedBooks(bookMasters, param2).map((book, index) => (
                            <div 
                                key={book.bookCode} 
                                onClick={() => scrollToDetail(book.bookCode)} 
                                className="image-item flex flex-col justify-center items-center mx-2 my-2"
                                style={{ cursor: 'pointer', width: '100px' }}
                            >
                                <img 
                                    src={`/api/bookworldthumb/${book.bookImage}.png`}
                                    alt={"No Image " + book.bookTitle} 
                                    style={{ width: '100px', height: 'auto' }}  
                                />
                            </div>
                            ))}
                        </div>
                        <div className="count-container text-center mt-4">
                            <p className="text-white">
                            We have {filteredAndSortedBooks(bookMasters, param2).length} Items in {toProperCase(param2)} Book World!!
                            </p>
                        </div>
                    </div>
                    {filteredAndSortedBooks(bookMasters, param2).map((book, index) => (
                        <div key={book.bookCode} id={`book-detail-${book.bookCode}`} className="book-item">
                            <div className="thumb-book-image-container">
                                <img 
                                    src={`/api/bookworldthumb/${book.bookImage}.png`}
                                    alt={"No Image " + book.bookTitle} 
                                    style={{ width: '100px', height: 'auto' }}
                                />
                            </div>
                            <div className="details-container">
                                <h2 className='book-title'>{book.bookTitle}</h2>
                            </div>
                            <div className="details-container mt-2 mb-2">
                                <Tooltip text={book.hasPracticeTest === 1 ? "This has Practice Test" : "This has no Practice Test"} position={"top"}>
                                    <span className={`text-${book.hasPracticeTest === 1 ? 'green' : 'blue'}-500 mr-4`}>
                                        {book.hasPracticeTest === 1 ? (
                                            <FontAwesomeIcon icon={faCheck} className="text-2xl" />
                                        ) : (
                                            <FontAwesomeIcon icon={faCheck} className="text-blue-500 text-2xl" />
                                        )}
                                    </span>
                                </Tooltip>
                                <Tooltip text={book.hasAssignment === 1 ? "This has Assignment" : "This has no Assignment"} position={"top"}>
                                    <span className={`text-${book.hasAssignment === 1 ? 'green' : 'blue'}-500 mr-4`}>
                                        {book.hasAssignment === 1 ? (
                                            <FontAwesomeIcon icon={faFileAlt} className="text-2xl" />
                                        ) : (
                                            <FontAwesomeIcon icon={faFileAlt} className="text-blue-500 text-2xl" />
                                        )}
                                    </span>
                                </Tooltip>
                                <Tooltip text={book.hasExam === 1 ? "This has Exam" : "This has no Exam"} position={"top"}>
                                    <span className={`text-${book.hasExam === 1 ? 'green' : 'blue'}-500 mr-4`}>
                                        {book.hasExam === 1 ? (
                                            <FontAwesomeIcon icon={faClipboardCheck} className="text-2xl" />
                                        ) : (
                                            <FontAwesomeIcon icon={faClipboardCheck} className="text-blue-500 text-2xl" />
                                        )}
                                    </span>
                                </Tooltip>
                                <Tooltip text={book.hasCertificate === 1 ? "This has Certificate" : "This has no Certificate"} position={"top"}>
                                    <span className={`text-${book.hasCertificate === 1 ? 'green' : 'blue'}-500 mr-4`}>
                                        {book.hasCertificate === 1 ? (
                                            <FontAwesomeIcon icon={faCertificate} className="text-2xl" />
                                        ) : (
                                            <FontAwesomeIcon icon={faCertificate} className="text-blue-500 text-2xl" />
                                        )}
                                    </span>
                                </Tooltip>
                            </div>
                            {myBooks.find(myBook => myBook.bookId === book._id) && (
                                <>
                                    <div className="details-container mt-2">
                                        <p className="text-blue-800 bg-yellow-400 text-xl">This is already available in your BookShelf</p>
                                        <p className="text-purple-500 text-xl">You may <strong>Gift It</strong> to someone else</p>
                                    </div>
                                    <div className="details-container">
                                        <button
                                            onClick={() => handleBookDetailsClick(book._id, book.bookTitle, book, true, book.isFree, book.isCollection)}
                                            style={{ maxWidth: '150px' }}
                                        >
                                            Explore
                                        </button>
                                    </div>
                                </>
                            )}
                            {myBooks.find(myBook => myBook.isSampleBuy === true) && (
                                <>
                                    <div className="details-container mt-2">
                                        <p className="text-white bg-green-800 text-xl">This is available as Sample in your BookShelf</p>
                                    </div>
                                    <div className="details-container mt-4">
                                        <button
                                            onClick={() => handleBookDetailsClick(book._id, book.bookTitle, book, false, book.isFree, book.isCollection)}
                                            style={{ maxWidth: '150px' }}
                                        >
                                            Enable Full Version
                                        </button>
                                    </div>
                                </>
                            )}
                            <div className="details-container mt-2">
                                <h2 className={`${book.isAvailable === 1 ? 'text-green-500' : 'text-yellow-500'} text-xl mt-2`}>
                                    {book.isAvailable === 1 ? "Available in the Store" : "Currently Unavailable"}
                                </h2>
                            </div>
                            {book.isCollection && (
                                <>
                                    <div className="details-container">
                                        <button
                                            onClick={() => toggleCollectionBookList(book._id)}
                                            style={{ maxWidth: '150px' }}
                                        >
                                            {collectionStates[book._id] ? 'Hide Book List' : 'Show Book List'}
                                        </button>
                                    </div>
                                    {collectionStates[book._id] && (
                                        <>
                                            <div className="details-container">
                                                <p className="text-purple-500 text-xl">List of Books in the collection {book.bookTitle}</p>
                                            </div>
                                            {subCollectionBooks[book._id] && subCollectionBooks[book._id].map((collectionbooks, collectionbooksIndex) => (
                                                <div key={collectionbooksIndex} className={collectionbooksIndex % 2 === 0 ? 'bg-blue-600' : 'bg-blue-600'}>
                                                    <p><strong>{collectionbooksIndex + 1}{'. '}{collectionbooks.bookTitle}</strong></p>
                                                </div>
                                            ))}
                                        </>
                                    )}
                                </>
                            )}
                            {myBooks.every(myBook => myBook.bookId !== book._id) && (
                                <>
                                    <div className="details-container mt-2">
                                        {book.isFree === 1 && (
                                            <h2 className="text-purple-500 text-xl">Add in Your BookShelf for Free</h2>
                                        )}
                                    </div>
                                    <div className="details-container mt-2">
                                        {book.isFree === 0 && (
                                            <h2 className="text-purple-500 text-xl">Buy for Yourself or Gifting</h2>
                                        )}
                                    </div>
                                    <div className="details-container">
                                        <button
                                            onClick={() => handleBookDetailsClick(book._id, book.bookTitle, book, false, book.isFree, book.isCollection)}
                                            style={{ maxWidth: '150px' }}
                                        >
                                            Details
                                        </button>
                                    </div>
                                </>
                            )}

                            {book.isAuthorOffer === true && (
                                <div className="details-container mb-4">
                                    <p className="bg-purple-700 text-white"> The Book has an Offer from the Author</p>
                                    <p>{book.authorOffer}</p>
                                </div>
                            )}
                            {book.isPublisherOffer === true && (
                                <div className="details-container mb-4">
                                    <p className="bg-purple-700 text-white"> The Book has an Offer from the Publisher</p>
                                    <p>{book.publisherOffer}</p>
                                </div>
                            )}
                            {book.isPlatformOffer === true && (
                                <div className="details-container mb-4">
                                    <p className="bg-purple-700 text-white"> The Book has an Offer from Think5Whys</p>
                                    <p>{book.platformOffer}</p>
                                </div>
                            )}
                            {book.isSellerOffer === true && (
                                <div className="details-container mb-4">
                                    <p className="bg-purple-700 text-white"> The Book has an Offer from Sellers</p>
                                    <p>{book.sellerOffer}</p>
                                </div>
                            )}
                            {book.isOtherOnline === true && (
                                <div className="details-container mb-4 text-white bg-blue-500">
                                    {/* {book.isOtherOnline ? "yes": "mo"}{' index'} {index} */}
                                    <p className="bg-purple-700 text-white"> The Book is available on other online stores also</p>
                                    {book.otherOnline.map((online, onlineindex) => (
                                        online.isActive && (
                                            <div key={onlineindex} className="seller-item mb-1 text-white">
                                                <h3 className='text-bold'>{online.siteName}</h3>
                                                <p className='text-red-500 hover:underline'><a href={online.siteUrl} target="_blank" rel="noopener noreferrer">{online.siteUrl}</a></p>
                                                <p>{online.siteRemarks}</p>
                                                <p>Price: {online.sitePrice}</p>
                                                <p><FontAwesomeIcon icon={faDiamond} className="text-yellow-500 text-2xl" /></p>
                                            </div>
                                        )
                                    ))}
                                </div>
                            )}
                            {book.isPrinted === true && (
                                <div className="details-container mb-4">
                                    <p className="bg-gray-700 text-white"> The Book has paperback edition</p>
                                </div>
                            )}
                            {book.isBookStores === true && (
                                <div className="details-container mb-4 text-white bg-blue-500">
                                    <p className="bg-purple-700 text-white">The Book has paperback edition and is available on Book Stores</p>
                                    <p className="font-bold">Input your PIN/Postal Code to Search Stores Name near you</p>
                                    <div className="mt-4">
                                        {book.bookStores.map((store, storeindex) => (
                                            store.isActive && store.isAvailable && (
                                                <div key={storeindex} className="store-item mb-1 text-white">
                                                    <h3>{store.storeName}</h3>
                                                    <p>{store.storeDesc}</p>
                                                    <p>{store.storeAddress}</p>
                                                    <p>{store.storeContact}</p>
                                                    <p>Offer Price: {store.offerPrice}</p>
                                                    <p>Offer Description: {store.offerDesc}</p>
                                                    <p>Offer Start Date: {new Date(store.offerStartDate).toLocaleDateString()}</p>
                                                    <p>Offer End Date: {new Date(store.offerEndDate).toLocaleDateString()}</p>
                                                    <p><FontAwesomeIcon icon={faDiamond} className="text-yellow-500 text-2xl" /></p>
                                                </div>
                                            )
                                        ))}
                                    </div>
                                </div>
                            )}
                            {book.isSecondHand === true && (

                                <div className="details-container mb-4 text-white bg-blue-500">
                                    <p className="bg-blue-700 text-white">Second-hand copies of the book are available</p>
                                    <div className="mt-4">
                                        {book.secondHand.map((item, secondhandindex) => (
                                            item.isActive && item.isAvailable && (
                                                <div key={secondhandindex} className="second-hand-item mb-1 text-white">
                                                    <h3>{item.sellerName}</h3>
                                                    <p>{item.sellerAddress}</p>
                                                    <p>{item.sellerContact}</p>
                                                    <p>{item.sellerRemarks}</p>
                                                    <p>Offer Price: {item.offerPrice}</p>
                                                    <p>Offer Description: {item.offerDesc}</p>
                                                    <p><FontAwesomeIcon icon={faDiamond} className="text-yellow-500 text-2xl" /></p>
                                                </div>
                                            )
                                        ))}
                                    </div>
                                </div>
                            )}
                            {book.bookHighlight !== "" && (
                                <>
                                    <div className="details-container">
                                        <button
                                            onClick={() => toggleHighlight(book._id)}
                                            style={{ maxWidth: '150px' }}
                                        >
                                            {highlightStates[book._id] ? 'Hide Highlights' : 'Show Highlights'}
                                        </button>
                                    </div>
                                    {highlightStates[book._id] && (
                                        <div className="highlight-container" dangerouslySetInnerHTML={{ __html: book.bookHighlight }} />
                                    )}
                                </>
                            )}
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default BookWorldListComponent;
